import React from 'react';
import { handleGAEvents } from '../../adapters/helpers/Utils';

interface linkContentFields {
  ctaName?: string;
  ctaUrl?: string;
  anchorId?: string;
  gaEventCategory?: string;
  gaEventAction?: string;
  gaEventLabel?: string;
}

interface ArticleLinkProps {
  linkContent?: {
    fields?: linkContentFields;
  };
}

const ArticleLink: React.FC<ArticleLinkProps> = ({ linkContent }) => {
  const linkName = linkContent?.fields?.ctaName || '';
  const linkUrl = linkContent?.fields?.ctaUrl || '';
  const gaEventCategory = linkContent?.fields?.gaEventCategory || '';
  const gaEventAction = linkContent?.fields?.gaEventAction || '';
  const gaEventLabel = linkContent?.fields?.gaEventLabel || '';
  
  const handleLinkClick = () => {
    handleGAEvents(gaEventCategory, gaEventAction, gaEventLabel);
    if (linkUrl) {
      window.open(linkUrl, '_blank');
    }
  };

  return (
    <div className='font-regular pb-3 px-2h md:px-0'>
          <a className='text-revamp_blueText !underline focus:outline font-regular text-base lg:text-xl' href={linkUrl} target='_blank' onClick={handleLinkClick}>
            {linkName}
          </a>
    </div>
  );
};

export default ArticleLink;